import { LeftOutlined } from '@ant-design/icons'
import { Button, Card, Divider, Flex, Spin } from 'antd'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useTreatmentServiceGetEpidemiologyCaseEndpoint } from 'src/api/queries'
import { Permissions } from 'src/api/requests'
import { PageBreadcrumbs } from 'src/components'
import {
  EpidemiologyFinalDiagnosticDetailsCard,
  EpidemiologyNotificationDetailsCard,
  EpidemiologyPatientInformationDetailsCard,
  EpidemiologyPrimaryDiagnosticDetailsCard,
  EpidemiologyRegistrationDetailsCard,
  EpidemiologySymptomsDetailsCard
} from 'src/features/persons/pages/epidemiology-cases/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import { RequestAccessModal } from '../components'

export const CasesDetailsPage = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const navigate = useNavigate()

  const { hasPermission } = useUser()

  const [isOpen, setIsOpen] = useState(false)

  const { data, isLoading } = useTreatmentServiceGetEpidemiologyCaseEndpoint(
    { id: String(id) },
    [id],
    { enabled: !!id }
  )

  const onToggle = () => setIsOpen((prev) => !prev)

  if (isLoading) return <Spin spinning fullscreen />

  return (
    <PageBreadcrumbs
      title={String(data?.code)}
      items={[{ title: t('menu.cases') }, { title: String(data?.code) }]}
      extra={
        !data?.userHasAccessToPersonalData &&
        hasPermission(
          Permissions.TREATMENT_EPIDEMIOLOGY_CASE_ADD_REQUEST_ALL
        ) && (
          <Button type="primary" onClick={onToggle}>
            {t('cases.request_access')}
          </Button>
        )
      }
      extraProps={{ align: 'flex-end' }}
    >
      <Button
        icon={<LeftOutlined />}
        className="fit-content"
        onClick={() => navigate(-1)}
      >
        {t('common.back')}
      </Button>

      <Divider />

      <Card>
        <Flex vertical gap={24}>
          {data?.form?.notification && (
            <EpidemiologyNotificationDetailsCard
              notification={data.form.notification}
            />
          )}

          {data?.form?.primaryDiagnostic && (
            <EpidemiologyPrimaryDiagnosticDetailsCard
              primaryDiagnostic={data.form.primaryDiagnostic}
            />
          )}

          {data?.form?.patient && (
            <EpidemiologyPatientInformationDetailsCard
              patient={data.form.patient}
            />
          )}

          {data?.form?.registration && (
            <EpidemiologyRegistrationDetailsCard
              registration={data.form.registration}
            />
          )}

          {data?.form?.symptoms && (
            <EpidemiologySymptomsDetailsCard symptoms={data.form.symptoms} />
          )}

          {data?.form?.finalDiagnostic && (
            <EpidemiologyFinalDiagnosticDetailsCard
              finalDiagnostic={data.form.finalDiagnostic}
            />
          )}
        </Flex>
      </Card>

      {isOpen && <RequestAccessModal onCancel={onToggle} />}
    </PageBreadcrumbs>
  )
}
